import LayoutPanel from '@/templates/LayoutPanel.vue';
import CommonRouter from '@/route/common';
import CustomerRouter from '@/route/customer';
import AdminRouter from '@/route/admin';
import roles from '@/settings/roles';
import redirectPages from '@/settings/redirect-pages';

export default [
  {
    path: '/',
    name: 'app',
    component: LayoutPanel,
    meta: {
      forAuth: true,
    },
    children: [
      {
        path: `/${roles.admin}`,
        name: 'admin',
        component: () => import(/* webpackPrefetch: true */ '@/templates/Admin.vue'),
        redirect: `${roles.admin}/mail`,
        children: AdminRouter,
        meta: {
          forAuth: true,
          roles: [roles.admin]
        }
      },
      {
        path: `/${roles.customer}`,
        name: 'customer',
        component: () => import(/* webpackPrefetch: true */ '@/templates/Customer.vue'),
        redirect: `${roles.customer}/mail`,
        children: CustomerRouter,
        meta: {
          forAuth: true,
          roles: [roles.customer]
        }
      },
      {
        path: '/redirect',
        name: 'redirect',
        component: {
          name: 'redirect',
          created() {
            if (this.$store.getters['auth/user'].role && this.$route.query.page)
              this.$router.replace(`/${this.$store.getters['auth/user'].role}/${this.$route.query.page}`);
          },
          render(createElement) {
            return createElement();
          }
        },
        meta: {
          forAuth: true,
        }
      },
      {
        path: '/help',
        name: 'help',
        component: () => import('@/views/common/pages/Help.vue'),
        meta: {
          forAuth: true
        }
      }
    ],
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import(/* webpackPrefetch: true */ '@/templates/Auth.vue'),
    redirect: 'login',
    meta: {
      forVisitors: true,
    },
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackPrefetch: true */ '@/views/auth/Login.vue'),
        meta: {
          forVisitors: true,
        },
      },
      {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import(/* webpackPrefetch: true */ '@/views/auth/ResetPassword.vue'),
        meta: {
          forVisitors: true,
        },
      },
    ],
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import(/* webpackPrefetch: true */ '@/templates/Registration.vue'),
    redirect: 'sign-up',
    meta: {
      forVisitors: true,
    },
    children: [{
      path: '/sign-up',
      name: 'sign-up',
      component: () => import(/* webpackPrefetch: true */ '@/views/SignUp.vue'),
      meta: {
        forVisitors: true,
      },
    },
    {
      path: '/select-plan',
      name: 'select-plan',
      component: () => import(/* webpackPrefetch: true */ '@/views/SelectPlan.vue'),
      meta: {
        forVisitors: true,
      }
    },
    {
      path: '/billing-info',
      name: 'billing-info',
      component: () => import(/* webpackPrefetch: true */ '@/views/BillingInfo.vue'),
      meta: {
        forVisitors: true,
      }
    },
    {
      path: '/get_voffice',
      name: 'get-voffice',
      component: () => import(/* webpackPrefetch: true */ '@/views/GuestSelectPlan.vue'),
      meta: {
        forVisitors: true
      }
    }]
  },
  {
    path: '/connect',
    name: 'connect',
    component: () => import('@/views/common/pages/integrations/connect.vue'),
    meta: {
      forVisitors: true,
    },
  },
  {
    path: '/configure',
    name: 'configure',
    component: () => import('@/views/common/pages/integrations/configure.vue'),
    meta: {
      forVisitors: true,
    },
  },
  {
    path: '/tutorial',
    name: 'tutorial',
    component: () => import('@/views/common/pages/Help.vue'),
    meta: {
      forVisitors: true
    }
  },
  {
    path: '/reload',
    name: 'page-reload',
    component: () => import('@/views/Reload.vue')
  },
  {
    path: '/:page',
    name: 'page-redirect',
    component: {
      name: 'redirect-component',
      components: {
        'page-404': () => import('@/views/404.vue'),
      },
      data() {
        return {
          show404: false
        };
      },
      created() {
        if (redirectPages.includes(this.$route.params.page)) {
          this.$router.replace({
            name: 'redirect', 
            query: {
              page: this.$route.params.page
            }
          });
        } else {
          this.show404 = true;
        }
      },
      render(createElement) {
        return this.show404 ? createElement('components', {is: 'page-404'}) : createElement();
      },
    }
  },
  {
    name: 'page-404',
    path: '*', 
    component: () => import('@/views/404.vue'),
  }
]